import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import GenericGuideModal from 'chameleon/ui-stack/ui/modals/guide-modal';

import {
  SearchGuideModalType,
  SearchTipsByPageType,
  SearchModalTitleByPageType,
  SearchModalContentByPageType,
  getTableSearchTips,
} from './types';

const SearchGuideModal = ({ button, page }) => {
  const tableList = useMemo(
    () =>
      SearchTipsByPageType[page].map((name) => getTableSearchTips(page)[name]),
    [page],
  );
  const Content = useMemo(() => SearchModalContentByPageType[page], [page]);

  return (
    <GenericGuideModal
      title={SearchModalTitleByPageType[page]}
      tableContent={tableList}
      button={button}
      size="big"
    >
      <Content />
    </GenericGuideModal>
  );
};

SearchGuideModal.prototype = {
  page: PropTypes.oneOf([
    SearchGuideModalType.Assessments,
    SearchGuideModalType.QuestionBank,
    SearchGuideModalType.StudentAssignments,
  ]),
};

export default SearchGuideModal;
